export const productPages = {
  'CPA-HUB-345-1': 'https://www.covesmart.com/products/alarm-panel-hub/',
  'CPA-PANEL-345-1': 'https://www.covesmart.com/products/alarm-panel-hub/',
  'CP-DS-345-1': 'https://www.covesmart.com/products/door-sensor/',
  'CP-WS-345-1': 'https://www.covesmart.com/products/window-sensor/',
  'CP-PIR-345-1': 'https://www.covesmart.com/products/motion-detector/',
  '2G-GB-345-1': 'https://www.covesmart.com/products/glass-break-detector/',
  'secondary-siren': 'https://www.covesmart.com/products/siren/',
  '2GIG-SMKT8-345': 'https://www.covesmart.com/products/smoke-detector/',
  '2GIG-CO8-345': 'https://www.covesmart.com/products/co-detector/',
  'CP-FS-345-1': 'https://www.covesmart.com/products/flood-sensor/',
  'CP-KEY-345-1': 'https://www.covesmart.com/products/key-remote/',
  'CP-MED-345-1': 'https://www.covesmart.com/products/panic-button/',
  'indoor-camera-eufy': 'https://www.covesmart.com/products/indoor-camera/',
  'doorbell-camera-eufy':
    'https://www.covesmart.com/products/doorbell-camera-eufy/',
  'outdoor-camera-eufy': 'https://www.covesmart.com/products/outdoor-camera/',
} as const;
